export default __webpack_public_path__ + "static/media/zoomIn.a95602b5.svg";